"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _HighscoreService = _interopRequireDefault(require("../HighscoreService"));

var _QuizActions = _interopRequireDefault(require("../../actions/QuizActions"));

var QuestionSetStatus = /*#__PURE__*/function () {
  function QuestionSetStatus(levelId, levelName, number, levelStatus, isTraining) {
    (0, _classCallCheck2["default"])(this, QuestionSetStatus);
    this.levelId = levelId;
    this.status = levelStatus;
    this.rounds = {};
    this.name = levelName;
    this.isTraining = isTraining;
    console.log({
      isTraining: isTraining
    });
    this.number = number;
    this.currentRound = undefined;
    this.nextRound = _HighscoreService["default"].getPlayedRoundsInLevel(levelId);
    this.highscore = _HighscoreService["default"].getLevelHighscore(levelId);
  }

  (0, _createClass2["default"])(QuestionSetStatus, [{
    key: "numberHuman",
    value: function numberHuman() {
      return this.number + 1;
    }
  }, {
    key: "minLoadedRoundNumber",
    value: function minLoadedRoundNumber() {
      if ((0, _keys["default"])(this.rounds).length === 0) {
        return 0;
      }

      return Math.min.apply(Math, (0, _toConsumableArray2["default"])((0, _keys["default"])(this.rounds)));
    }
  }, {
    key: "roundCount",
    value: function roundCount() {
      return (0, _keys["default"])(this.rounds).length;
    }
  }, {
    key: "numberOfRemainingRounds",
    value: function numberOfRemainingRounds() {
      return this.roundCount() - this.nextRound + this.minLoadedRoundNumber();
    }
  }, {
    key: "getHighscore",
    value: function getHighscore() {
      this.highscore = _HighscoreService["default"].getLevelHighscore(this.levelId);
      this.sortHighscore();
      return this.highscore;
    }
  }, {
    key: "isTrainingLevel",
    value: function isTrainingLevel() {
      return this.isTraining;
    }
  }, {
    key: "sortHighscore",
    value: function sortHighscore() {
      if (!this.highscore) {
        return;
      }

      this.highscore.sort(function (a, b) {
        if (a.points === b.points) {
          return 0;
        }

        if (a.points > b.points) {
          return -1;
        }

        return 1;
      });
      var rank = 0;
      var lastPoints = null;
      var ranksToSkip = 0;
      this.highscore.forEach(function (score) {
        if (score.points === null || score.rank === null) {
          throw new Error('something expected is not defined');
        }

        if (score.points !== lastPoints) {
          rank += 1 + ranksToSkip;
          ranksToSkip = 0;
        } else {
          ranksToSkip += 1;
        } // noinspection Eslint (reason: directly modifying the parent object)


        score.rank = rank; // eslint-disable-line

        lastPoints = score.points;
      });
    }
  }, {
    key: "getCurrentRound",
    value: function getCurrentRound() {
      return this.rounds[this.nextRound];
    }
  }, {
    key: "addPointsFromRoundToHighscoreList",
    value: function addPointsFromRoundToHighscoreList() {
      var round = this.getCurrentRound();
      round.update();

      if (round.passed) {
        if (!round.addedToHighscoreList) {
          // action to change the store
          _QuizActions["default"].addLevelPoints({
            levelId: this.levelId,
            points: round.points
          });

          round.addedToHighscoreList = true;
        }

        this.nextRound += 1;
      }
    }
  }]);
  return QuestionSetStatus;
}();

exports["default"] = QuestionSetStatus;